import styled from 'styled-components'

export const TaskTagNewStyled = styled.div`
  display: flex;
  gap: 12px;
  margin-bottom: 24px;
  font-size: 14px;
  line-height: 1.4;
  color: var(--t-text-primary);
`

export const TextCell = styled.div`
  padding: 10px 16px;
  border-radius: 8px;
  background-color: var(--t-surface-2);
  min-height: 40px;
  max-width: 294px;
  width: 100%;
  overflow: hidden;
  overflow-wrap: break-word;
  word-break: break-word;
`

export const ColorCell = styled.div`
  background-color: var(--t-surface-2);
  height: 40px;
  border-radius: 8px;
  padding: 0 17px;
  display: flex;
  align-items: center;

  &::before {
    content: '';
    display: block;
    width: 20px;
    height: 20px;
    background-color: ${({ color }) => color};
  }
`

export const CheckboxCell = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 42px;
  background-color: var(--t-surface-2);
  border-radius: 8px;
  color: var(--t-checkbox-wrap-text);
  flex: 1 0 40px;
`

export const FormButtonWrap = styled.div`
  width: 40px;

  button {
    padding: 0 20px;
    display: block;
    color: var(--t-tags-delete-button-color);
  }

  svg {
    position: absolute;
    top: 50%;
    left: 50%;
    margin-right: 0;
    transform: translate(-50%, -50%);
  }
`

export const Cell = styled.div`
  width: 40px;
  height: 42px;
  flex: 1 0 auto;
`
